import styled from 'styled-components';

const AlarmDot = styled.span`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border-radius: ${props => props.size / 2}px;
`;

AlarmDot.defaultProps = {
  size: 10
};

export default AlarmDot;
